import * as React from 'react';
import {Component} from 'react';
import Typography from '@mui/material/Typography';
import {Avatar, Card, CardContent, Grid, Stack} from "@mui/material";
import {connect} from "react-redux";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonIcon from '@mui/icons-material/Person';

class GroupDetailPopover extends Component {

    constructor(props) {
        super(props);
        this.state = this.initState();
    }

    initState = () => {
        return {}
    }


    componentDidMount() {
    }

    getUserComponent = (name) => {
        return <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <PersonIcon sx={{color: "dark-gray"}}/>
            <Typography variant="body1"
                        sx={{fontWeight: "light", fontSize: '12px', color: 'light-gray'}}>
                {name}
            </Typography>
        </Stack>
    }

    render() {
        return <Card sx={{minWidth: 250}}>
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Avatar><PeopleAltIcon/></Avatar>
                    </Grid>
                    <Grid item xs={8}>
                        <Stack direction="column" alignItems={"end"}>
                            <Typography variant="body1" sx={{fontWeight: "bold"}}>
                                {this.props.data.display_name}
                            </Typography>
                            <Typography variant="body1"
                                        sx={{fontWeight: "light", fontSize: '12px', color: 'light-gray'}}>
                                {this.props.data.users.length} members
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={6}>
                        <Stack direction={"column"}>
                            {this.props.data.users.slice(this.props.data.users.length / 2, this.props.data.users.length).map((item) => this.getUserComponent(item))}
                        </Stack>
                    </Grid>
                    <Grid item xs={6}>
                        <Stack direction={"column"}>
                            {this.props.data.users.slice(0, this.props.data.users.length / 2).map((item) => this.getUserComponent(item))}
                        </Stack>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    }
}

const mapStateToProps = state => {
    return {};
};

export default connect(mapStateToProps)(GroupDetailPopover);